<div class="topline">
  <div class="container container_type_topline">
    <div class="topline__part">
      <a href="https://beeline.ru/customers/products/" class="topline__link">{{ 'top-line.customers' | translate }}</a>
      <a href="https://beeline.ru/business/main/" class="topline__link">{{ 'top-line.business' | translate }}</a>
    </div>
    <div class="topline__part">
      <a routerLink="" (click)="openCorpLogin()" class="topline__link">{{ 'top-line.corporate-login' | translate }}</a>
    </div>
  </div>
</div>
